import React from 'react';
import Loader from '../../../../utils/Loader';
import InformationModal from '../../../common/informationModal';
import { taskSubmitSuccessful } from '../../../../utils/const';
import {
	changeFileValue,
	submitAssignment,
	changeFileError,
} from '../../../../redux/myCourse/myCourse.actions';
import { connect } from 'react-redux';
import { compose } from 'redux';

class SubmitFile extends React.Component {
	constructor(props) {
		super(props);
		Loader.hide();
		this.handleUploadImage = this.handleUploadImage.bind(this);
		this.validateFileSize = this.validateFileSize.bind(this);
	}

	handleUploadImage(ev) {
		ev.preventDefault();
		Loader.show();
		let fileName = this.props.fileName;
		let isValidExtension = /\.(docx|doc|mp3|mp4|m4a)$/i.test(fileName);

		if (!isValidExtension) {
			Loader.hide();
			this.props.changeFileError(
				'Please upload a file with valid formats(.docx, .doc, .mp3, .mp4 or m4a).',
			);
			return false;
		}
		this.props.submitAssignment();
	}

	validateFileSize(e) {
		const { changeFileError, changeFileValue } = this.props;
		const fsize = Math.round(e.target.files[0].size / 1024);
		if (fsize >= 10240) {
			changeFileError('Please upload a file with size within 10MB.');
			return false;
		} else {
			this.props.changeFileError('');
			changeFileValue(e);
		}
	}

	render() {
		let { fileError, fileName, id } = this.props;
		return (
			<div>
				<div id={`divSubmitFile_${id}`} style={{ display: 'none' }}>
					<div
						className="taskErrorMessage"
						id="incorrectFile"
						style={{ display: !!fileError ? 'block' : 'none' }}
					>
						{fileError}
					</div>

					{/*<div className="coach-table-title">Submit Task</div>*/}

					<form onSubmit={this.handleUploadImage}>
						<div className="row">
							<div className="col-lg-12 col-xs-12 col-md-12">
								<div className="input-group image-preview">
									<input
										placeholder="Browse file to upload"
										id="fileHolder"
										value={fileName}
										type="text"
										className="form-control image-preview-filename"
										disabled="disabled"
									/>
									<span className="input-group-btn">
										<div className="btn btn-default image-preview-input">
											<span className="image-preview-input-title" id="browseFile">
												Browse
											</span>
											<input
												type="file"
												ref={(ref) => {
													this.uploadInput = ref;
												}}
												accept=".docx,.doc,.mp3,.mp4,.png,.jpeg,.jpg,.m4a"
												onChange={this.validateFileSize}
												name="input-file-preview"
											/>
										</div>
										<button
											aria-label="upload"
											type="submit"
											className={` btn btn-labeled btn-primary`}
										>
											{' '}
											<span className="btn-label"></span>Upload
										</button>
									</span>
								</div>
							</div>
						</div>
					</form>
					<p className="accept_file_text">
						Accepted file formats .docx .doc for writing task. We accept .mp3 .mp4
						.m4a for speaking task.
					</p>

					<InformationModal
						information={taskSubmitSuccessful}
						returnPath="/submitAssignment"
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const { fileError, fileName } = state.rootReducer.myCourse;
	return {
		fileError,
		fileName,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		submitAssignment: () => dispatch(submitAssignment()),
		changeFileValue: (e) => dispatch(changeFileValue(e.target)),
		changeFileError: (err) => dispatch(changeFileError(err)),
	};
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
	SubmitFile,
);
